<template>
    <div>
        <HeaderPreviousEditions title="Edició 2025">
            <a
                href="https://hikeandfly.puntxat.cat/admin/storage/hf_bergueda_normativa_2025.pdf"
                class="navbar-item"
                >Normativa</a
            >
        </HeaderPreviousEditions>

        <Ranking
            v-show="showPilotsRanking"
            ref="ranking"
            v-bind:hasFilterByLeague="true"
            v-bind:leagues="leagues"
            v-bind:leagueSelected="leagueSelected"
            v-on:league-selected="setLeagueSelected"
        ></Ranking>
        <RankingPerTeams
            v-show="showTeamsRanking"
            v-bind:results="$options.RESULTS2025.data"
            v-bind:hasFilterByLeague="true"
            v-bind:leagues="leagues"
            v-bind:leagueSelected="leagueSelected"
            v-on:league-selected="setLeagueSelected"
        ></RankingPerTeams>
    </div>
</template>

<script>
import HeaderPreviousEditions from "../components/HeaderPreviousEditions.vue";
import Ranking from "../components/Ranking.vue";
import RankingPerTeams from "../components/RankingPerTeams.vue";
import results from "./ranking-2025.json";

export default {
    name: "Edition2025",
    RESULTS2025: results,
    components: {
        HeaderPreviousEditions,
        Ranking,
        RankingPerTeams,
    },
    data() {
        return {
            leagues: [
                {
                    key: null,
                    value: "Classificació general",
                    callback: this.openPilotsRanking,
                },
                {
                    key: "F",
                    value: "Classificació femenina",
                    callback: this.openPilotsRanking,
                },
                {
                    key: "T",
                    value: "Classificació per equips",
                    callback: this.openTeamRanking,
                },
            ],
            showPilotsRanking: true,
            showTeamsRanking: false,
            leagueSelected: {
                key: null,
                value: "Classificació general",
            },
        };
    },
    methods: {
        openPilotsRanking() {
            this.showPilotsRanking = true;
            this.showTeamsRanking = false;
        },
        openTeamRanking() {
            this.showPilotsRanking = false;
            this.showTeamsRanking = true;
        },
        setLeagueSelected(league) {
            this.leagueSelected = league;
        },
    },
    mounted() {
        this.$refs.ranking.loadData(this.$options.RESULTS2025.data);
        this.$root.$emit("ready");
    },
};
</script>
